import './StatusSupervisionHighLevel.scss'
import OverviewSection from '../../../../../common/components/overviewSection/OverviewSection'
import IIncidentOverview from '../../../../../common/interfaces/incidentOverview/IIncidentOverview'
import IncidentOverviewSupervisionHighestIncidentCount from '../../../../../common/interfaces/incidentOverview/IIncidentOverviewSupervisionHighestCancellationCount'
import React, { useState } from 'react'
import { currentLanguageFormatCode } from "../../../../../configuration"

type ComponentProps = {
  incidentOverview:null|undefined|IIncidentOverview
  handleActiveUserGuideTopicNameChangeRequest: (request:string) => void
}

const StatusSupervisionHighLevel = (props:ComponentProps) => {

  const referencedUsers:string[] = [...new Set(props.incidentOverview?.status?.detailedAnalysis?.supervision?.highestIncidentCount.map(item => item.user.userPrincipalName)), ...new Set(props.incidentOverview?.status?.detailedAnalysis?.supervision?.highestCancellationCount.map(item => item.user.userPrincipalName))]
  const distinctUsers:string[] = [...new Set(referencedUsers.map(item => item))]
  const distinctUserCount:number = (distinctUsers?.length) ?? 0

  const [usersLimitedIncidentCount, setUsersLimitedIncidentCount] = useState<boolean>(true)
  const [usersLimitedCancellationCount, setUsersLimitedCancellationCount] = useState<boolean>(true)
  
  const userCountLimit:number = 5

  const numberFormatter = new Intl.NumberFormat(currentLanguageFormatCode)

  const handleIncidentCountTitleClick = () => { 
    setUsersLimitedIncidentCount(previous => !previous) 
  }
  
  const handleCancellationCountTitleClick = () => { 
    setUsersLimitedCancellationCount(previous => !previous) 
  }

  return (
    <OverviewSection 
      contextID='statusSupervisionHighLevel' 
      incidentOverview={props.incidentOverview} 
      headerTitle='Tilsyn med dine brugere' 
      headerStatus={distinctUserCount ? (numberFormatter.format(distinctUserCount) + ' stk.') : ''}
      handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
    >

      <div id='status-supervision-high-level' onClick={() => props.handleActiveUserGuideTopicNameChangeRequest('incidentOverviewSupervision')}>
        <div className='status-supervision-users-section'>

          <div className='section-title' onClick={() => handleIncidentCountTitleClick()}>
            {
              'Antal hændelser - ' + 
              (
                usersLimitedIncidentCount ? 
                  'Vis flere brugere (' + props.incidentOverview?.status?.detailedAnalysis?.supervision?.highestIncidentCount.length.toString() + ' stk.)':
                  'Vis færre brugere (' + Math.min(distinctUserCount, userCountLimit).toString() + ' stk.)'
              )
            }
          </div>

          <div className='section-content'>

            <div className='section-content-column-header'>
              <div className='section-content-column-naming'>Navn</div>
              <div className='section-content-column-value-1'>Alle</div>
              <div className='section-content-column-value-2'>Overskredet</div>
            </div>

            <div className='section-content-row'>
            {
              props.incidentOverview?.status?.detailedAnalysis?.supervision?.highestIncidentCount &&
              props.incidentOverview?.status?.detailedAnalysis?.supervision?.highestIncidentCount.map((highestIncidentCount:IncidentOverviewSupervisionHighestIncidentCount, indexHighestIncidentCount:number) => {           
                
                let showItemIncidentCount:boolean = false
                
                if (!usersLimitedIncidentCount) 
                  showItemIncidentCount = true
                else
                  if (usersLimitedIncidentCount && indexHighestIncidentCount <= userCountLimit) showItemIncidentCount = true

                  return (
                    showItemIncidentCount &&                    
                    <React.Fragment key={indexHighestIncidentCount}>
                      <div className='section-content-column-naming'>
                        {highestIncidentCount.user.displayName}
                      </div>
                      <div className='section-content-column-value-1'>{numberFormatter.format(((highestIncidentCount.metrics.find(item => item.name === 'Count')?.value) ?? 0))}</div>
                      <div className='section-content-column-value-2'>{numberFormatter.format(((highestIncidentCount.metrics.find(item => item.name === 'DeadlineExceededCount')?.value) ?? 0))}</div>
                    </React.Fragment>
                  )
                })
            }
            </div>
          </div>

        </div>

        <div className='status-supervision-users-section'>

          <div className='section-title' onClick={() => handleCancellationCountTitleClick()}>
            {
              'Antal annulleringer - ' + 
              (
                usersLimitedCancellationCount ? 
                'Vis flere brugere (' + props.incidentOverview?.status?.detailedAnalysis?.supervision?.highestCancellationCount.length.toString() + ' stk.)' :
                'Vis færre brugere (' + Math.min(distinctUserCount, userCountLimit) + ' stk.)'
              )
            }
          </div>

          <div className='section-content'>

            <div className='section-content-column-header'>
              <div className='section-content-column-naming'>Navn</div>
              <div className='section-content-column-value-1'>Håndt.</div>
              <div className='section-content-column-value-2'>Fejlvurd.</div>
            </div>

            <div className='section-content-row'>
            {
              props.incidentOverview?.status?.detailedAnalysis?.supervision?.highestCancellationCount &&
              props.incidentOverview?.status?.detailedAnalysis?.supervision?.highestCancellationCount.map((highestCancellationCount:IncidentOverviewSupervisionHighestIncidentCount, indexHighestCancellationCount:number) => {

                let showItemCancellationCount:boolean = false
                
                if (!usersLimitedCancellationCount) 
                  showItemCancellationCount = true
                else
                  if (usersLimitedCancellationCount && indexHighestCancellationCount <= userCountLimit) showItemCancellationCount = true

                return (
                  showItemCancellationCount &&    
                  <React.Fragment key={indexHighestCancellationCount}>
                    <div className='section-content-column-naming'>{highestCancellationCount.user.displayName}</div>
                    <div className='section-content-column-value-1'>{numberFormatter.format(((highestCancellationCount.metrics.find(item => item.name === 'CancellationCorrectSystemAssessmentExternalHandling')?.value) ?? 0))}</div>
                    <div className='section-content-column-value-2'>{numberFormatter.format(((highestCancellationCount.metrics.find(item => item.name === 'CancellationIncorrectSystemAssessment')?.value) ?? 0))}</div>
                  </React.Fragment>
                )
              })
            }
            </div>
          </div>

        </div>
      </div>
    </OverviewSection>
  )
}

export default StatusSupervisionHighLevel